import React from 'react';

import AppLayout from '../App/AppLayout';

const AppRoute = (props) => <AppLayout {...props} />;

export default AppRoute;
